// extracted by mini-css-extract-plugin
export default {"Container":"NotFound_Container__LzUE8","Status":"NotFound_Status__3Xofe","Message":"NotFound_Message__B5RZi"};